var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("AppHeader"),
      _vm._v(" "),
      _c("SubHeader"),
      _vm._v(" "),
      _c("div", { staticClass: "app-body" }, [
        _vm.$store.getters.roleID === _vm.Roles.ADMIN
          ? _c(
              "div",
              [_c("Sidebar", { attrs: { "nav-items": _vm.navAdmin } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.roleID === _vm.Roles.SUPER_ADMIN
          ? _c("div", [_c("Sidebar", { attrs: { "nav-items": _vm.nav } })], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.roleID === _vm.Roles.MAINTENANCE
          ? _c(
              "div",
              [
                _c("Sidebar", {
                  attrs: { "nav-items": _vm.navMaintenanceManager },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.roleID === _vm.Roles.INSURANCE
          ? _c(
              "div",
              [
                _c("Sidebar", {
                  attrs: { "nav-items": _vm.navInsuranceManager },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.roleID === _vm.Roles.ANALYTICS
          ? _c(
              "div",
              [_c("Sidebar", { attrs: { "nav-items": _vm.navAnalytics } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.roleID === _vm.Roles.EXT_OPS
          ? _c(
              "div",
              [
                _c("Sidebar", {
                  attrs: { "nav-items": _vm.navExternalOperations },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.roleID === _vm.Roles.DEVICE_CONFIGURATION_MANAGER
          ? _c(
              "div",
              [
                _c("Sidebar", {
                  attrs: { "nav-items": _vm.navDeviceConfigurationManager },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("main", { staticClass: "main bg-white" }, [
          _c(
            "div",
            { staticClass: "container-fluid" },
            [_c("router-view", { key: _vm.$route.fullPath })],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("StatusBar"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }